// extracted by mini-css-extract-plugin
export default {"title":"ErrorModal_title__FX1V4","button":"ErrorModal_button__+txhC","show-modal":"ErrorModal_show-modal__s-Rfw","hide-modal":"ErrorModal_hide-modal__3Fepc"};